import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface StickyQuoteButtonProps {
  formId?: string;
  label?: string;
}

export default function StickyQuoteButton({ formId, label = "Request a Quote" }: StickyQuoteButtonProps) {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setPulse(true), 2000);
    const stopPulse = setTimeout(() => setPulse(false), 5000);
    return () => { clearTimeout(timer); clearTimeout(stopPulse); };
  }, []);

  const handleClick = () => {
    if (formId) {
      const el = document.getElementById(formId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
    }
    navigate("/contact");
  };

  return (
    <div
      className={`fixed bottom-8 right-6 z-40 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <button
        onClick={handleClick}
        className={`group flex items-center gap-2.5 bg-[#1a1a1a] text-white text-sm font-semibold px-5 py-3.5 rounded-full cursor-pointer whitespace-nowrap transition-all hover:bg-[#333] hover:gap-3 ${
          pulse ? "ring-4 ring-[#1a1a1a]/20" : ""
        }`}
      >
        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
          <i className="ri-mail-send-line text-base"></i>
        </div>
        <span>{label}</span>
        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 opacity-60 group-hover:opacity-100 transition-opacity">
          <i className="ri-arrow-right-line text-sm"></i>
        </div>
      </button>
    </div>
  );
}
